import { currencyFormatter, numberformatter } from './formatters';
import '../css/range-slider.css'

class RangeSlider {
    el: HTMLElement
    min: number
    max: number
    start: number
    end: number | null
    step: number
    minLabelSelector: string
    maxLabelSelector: string
    sliderMinName: string
    sliderMaxName: string
    color: string | null
    labelFormat: string | null

    sliderMin: HTMLInputElement
    sliderMax: HTMLInputElement | null
    sliderDiv: HTMLElement
    inverseLeft: HTMLElement
    inverseRight: HTMLElement
    rangeDiv: HTMLElement
    thumbLeft: HTMLElement
    thumbRight: HTMLElement | null

    constructor(triggerElement: HTMLElement) {
        this.el = triggerElement
        this.min = Number(this.el.getAttribute('min') ?? 0)
        this.max = Number(this.el.getAttribute('max') ?? 100)
        this.start = Number(this.el.getAttribute('start') ?? 1)
        this.step = Number(this.el.getAttribute('step') ?? 1)
        this.minLabelSelector = this.el.getAttribute('min-label-selector') ?? ''
        this.maxLabelSelector = this.el.getAttribute('max-label-selector') ?? ''
        this.sliderMinName = this.el.getAttribute('min-input-name') ?? 'SliderMinName'
        this.sliderMaxName = this.el.getAttribute('max-input-name') ?? 'SliderMaxName'
        this.color = this.el.getAttribute('color') ?? null
        this.labelFormat = this.el.getAttribute('label-format') ?? 'currency'
        let endv = this.el.getAttribute('end')
        this.end = Number(endv)

        // Create divs
        this.sliderDiv = document.createElement('div')
        this.inverseLeft = document.createElement('div')
        this.inverseRight = document.createElement('div')
        this.rangeDiv = document.createElement('div')
        this.thumbLeft = document.createElement('span')
        this.inverseLeft.setAttribute('inverse-left', '')
        this.inverseRight.setAttribute('inverse-right', '')
        this.rangeDiv.setAttribute('range', '')
        this.thumbLeft.setAttribute('thumb-left', '')
        this.sliderDiv.appendChild(this.inverseLeft)
        this.sliderDiv.appendChild(this.inverseRight)
        this.sliderDiv.appendChild(this.rangeDiv)
        this.sliderDiv.appendChild(this.thumbLeft)

        // Set color
        if (this.color) {
            this.thumbLeft.style.backgroundColor = this.color
            this.rangeDiv.style.backgroundColor = this.color
        }

        // Multislider append second thumb
        this.thumbRight = null
        if (this.end) {
            this.thumbRight = document.createElement('span')
            this.thumbRight.setAttribute('thumb-right', '')
            this.sliderDiv.appendChild(this.thumbRight)
            if (this.color) this.thumbRight.style.backgroundColor = this.color
        }

        this.el.appendChild(this.sliderDiv)

        // Create sliders
        this.sliderMin = document.createElement('input')
        this.sliderMin.type = 'range'
        this.sliderMin.min = String(this.min)
        this.sliderMin.max = String(this.max)
        this.sliderMin.step = String(this.step)
        this.sliderMin.value = String(this.start)
        this.sliderMin.name = this.sliderMinName
        this.el.appendChild(this.sliderMin)
        
        this.sliderMax = null
        if (this.end) {
            this.sliderMax = document.createElement('input')
            this.sliderMax.type = 'range'
            this.sliderMax.min = String(this.min)
            this.sliderMax.max = String(this.max)
            this.sliderMax.step = String(this.step)
            this.sliderMax.value = String(this.end)
            this.sliderMax.name = this.sliderMaxName
            this.el.appendChild(this.sliderMax)
        }

        // Initialize values
        this.sliderMinChanged(true)
        if (this.sliderMax) this.sliderMaxChanged(true)

        // Events
        this.sliderMin.oninput = () => this.sliderMinChanged(false)
        if (this.sliderMax) this.sliderMax.oninput = () => this.sliderMaxChanged(false)
    }

    convertToNewRange(originalValue: number, newMin: number, newMax: number) {
        // Hardcoded original range min and max values
        const originalMin = 0
        const originalMax = 100

        // Calculate the ratio of the new range to the original range
        let scale = (newMax - newMin) / (originalMax - originalMin)
        
        // Apply the ratio to the original value, adjusting by the new minimum
        let newValue = (originalValue - originalMin) * scale + newMin

        return newValue
    }

    sliderMinChanged(isInit: boolean) {
        if (this.sliderMin && this.sliderMax)
            this.sliderMin.value = String(Math.min(Number(this.sliderMin.value), Number(this.sliderMax.value) - 1));

        var value = (100 / (this.max - this.min)) * Number(this.sliderMin.value) - (100 / (this.max - this.min)) * this.min;
        this.inverseLeft.style.width = value + '%';

        let newVal = this.convertToNewRange(value, 0, 95)

        this.thumbLeft.style.left = newVal + '%'
        
        // Adjust Range
        if (this.end) {
            this.rangeDiv.style.left = value + '%'
        }
        else {
            this.rangeDiv.style.left = '0';
            this.rangeDiv.style.right = (100 - value) + '%'
        }
        
        // If single slider this function should also update inverse right
        if (!this.sliderMax)
            this.inverseRight.style.width = (100 - value) + '%';

        const txt = document.querySelector(this.minLabelSelector) as HTMLInputElement
        if (txt) {
            txt.value = this.formatValue(Number(this.sliderMin.value))

            if (isInit === false) {
                txt.dispatchEvent(new Event('input', {
                    'bubbles': true,
                    'cancelable': true
                }))
            }
        }
    }

    sliderMaxChanged(isInit: boolean) {
        if (this.sliderMin && this.sliderMax)
            this.sliderMax.value = String(Math.max(Number(this.sliderMax.value), Number(this.sliderMin.value) - (-1)));

        var value = (100 / (this.max - this.min)) * Number(this.sliderMax?.value) - (100 / (this.max - this.min)) * this.min;
        this.inverseRight.style.width = (100 - value) + '%';
        this.rangeDiv.style.right = (100 - value) + '%';

        let newVal = this.convertToNewRange(value, 4, 100)

        if (this.thumbRight)
            this.thumbRight.style.left = newVal + '%'

        // Set Text Label
        const txt = document.querySelector(this.maxLabelSelector) as HTMLInputElement
        if (txt) {
            txt.value = this.formatValue(Number(this.sliderMax?.value))

            if (isInit === false) {
                txt.dispatchEvent(new Event('input', {
                    'bubbles': true,
                    'cancelable': true
                }))
            }
        }

        //children[13].style.left = value + '%';
        //children[13].childNodes[1].innerHTML = obj.value;
    }

    private formatValue(val: number) {
        if (this.labelFormat === 'number')
            return numberformatter.format(val)
        else if (this.labelFormat === 'currency')
            return currencyFormatter.format(val)

        return String(val)
    }
}

document.querySelectorAll<HTMLElement>('[range-slider]').forEach(el => new RangeSlider(el))
